import Icon from '../components/Icon.vue'

Icon.register({
  'comment-dots': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 32c141.4 0 256 93.1 256 208s-114.6 208-256 208c-38.4 0-74.7-7.1-107.4-19.4-24.6 19.6-74.3 51.4-140.6 51.4-3.2 0-6-1.8-7.3-4.8s-0.7-6.4 1.5-8.7c0.5-0.5 42.3-45.4 54.8-95.8-35.6-35.7-57-81.1-57-130.7 0-114.9 114.6-208 256-208zM128 272c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM256 272c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM384 272c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/comment-dots.js
// module id = 1228
// module chunks = 0